import React from "react";
import * as rdd from "react-device-detect";
import "./device.scss";
export default function Device(props) {
  return <div className="device-layout-component">{props.children(rdd)}</div>;
}
